<script setup lang="ts">
import type { DataTableCellFormattedType } from '../dataTable.model';

import ContentCellContainer from './ContentCellContainer.vue';
import type { ContentCellContainerPropsType } from './types/contentCellContainerProps.type';

interface Props extends ContentCellContainerPropsType {
  type: DataTableCellFormattedType['type'];
}

defineProps<Props>();
</script>

<template>
  <ContentCellContainer v-bind="$props">
    <div v-if="type === 'dimension'" class="font-bold px-6 w-max">
      <div class="h-6 w-32 bg-gray-200 rounded-sm animate-pulse" />
    </div>
    <div v-else class="px-4 ml-auto w-max text-right flex flex-col items-end gap-1">
      <div class="h-6 w-12 bg-gray-200 rounded-sm animate-pulse" />
      <div class="h-6 w-16 bg-gray-200 rounded-sm animate-pulse" />
    </div>
  </ContentCellContainer>
</template>
